export const defaultPagination = {
  rows: 4,
  maxCols: 6,
  portion: 1,
};

export default {
  defaultPagination,
};
